import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { Currency } from '@shared/currency/currency';

import * as currencies from './currencies.json';

@Component({
  selector: 'mojo-currency-dropdown',
  templateUrl: './currency.component.html',
  styleUrls: ['./currency.component.scss'],
})
export class CurrencyComponent {
  items: Currency[];

  @Input()
  parentForm: UntypedFormGroup;

  @Input()
  controlName: string;

  constructor() {
    this.items = (currencies as any).default;
  }

  getSelectedValueCode() {
    if (this.parentForm && this.controlName) {
      const selectedValue: string = this.parentForm.get(this.controlName)?.value;
      const selectedCurrency = this.items.find(
        (currencyItem) => currencyItem.code === selectedValue,
      );
      return selectedCurrency?.code;
    }
  }
}
